var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71.664,
    height: 45.605,
    viewBox: "0 0 18.961 12.066",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style9"
  }, ".cls-1{fill:#ed1f48}.cls-3{fill:#72be44}"))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-113.215 -113.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1052",
    transform: "translate(103.369 113.74) scale(.17238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.05 55.16a.7.7 0 0 0-1.13-.06L58 62.4a4.82 4.82 0 0 0 7.62 5.89l6-7.15a.71.71 0 0 0-.39-1.14 10.87 10.87 0 0 1-6.18-4.84Z",
    id: "path15",
    style: {
      fill: "#ff3f46",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.233 25.607a4.81 4.81 0 0 0-7.28.4l-24.707 29.93 7.242 6.555 18.815-22.425a4.81 4.81 0 0 1 7.26-.4l4.89 5a.58.58 0 0 0 .86 0l4.46-5.71a.59.59 0 0 0 0-.74z",
    id: "path17",
    style: {
      fill: "#ff3f46",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.5 46.035 22.94-27.685c3.92-5.08-3.7-10.96-7.62-5.88l-23.18 27.47z",
    id: "path21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.09 59a4.81 4.81 0 0 0 7.29-.39L133 45.41a.57.57 0 0 0-.22-.89 10.67 10.67 0 0 1-6.23-5.52.56.56 0 0 0-1-.14L121 44.52a4.81 4.81 0 0 1-7.26.41l-4.89-5a.57.57 0 0 0-.85 0l-4.46 5.71a.56.56 0 0 0 0 .73z",
    id: "path23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m158.69 22.93-.12-11a3.6 3.6 0 0 0-3.57-3.3h-10.68a3.6 3.6 0 0 1-3.6-3.6V3.6a3.6 3.6 0 0 1 3.6-3.6h19a3.59 3.59 0 0 1 3.59 3.4l.2 19a3.59 3.59 0 0 1-3.59 3.8h-1.22a3.59 3.59 0 0 1-3.61-3.27z",
    id: "path27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logo-min.915c86fc377b6fc9d316b1c8810796c8.svg";
export { ForwardRef as ReactComponent };